// import store from '../app/store';
// import {logon} from '../redux/appAction';

// wealth restful version 3
const restWithErrorInfoStyle = (wResponse) => {
  // const {session} = store.getState();
  // const trackNum = wResponse.response.trackingNumber;
  wResponse.response.errorInfo.map(
    // eslint-disable-next-line
    (errInfo) => {
      const errReason = {
        status: 8,
        code: errInfo.code,
        // desc: errInfo.causes[0] + ' (correlation id: ' + session.correlationId + ')',
        // track: session.correlationId,
        //track: errInfo.extendedDetails.traceCode ? errInfo.extendedDetails.traceCode : trackNum
      };
      wResponse.reasons.push(errReason);
    },
  );
};

// wealth restful version 2
const restWithCodeOnlyInfoStyle = (wResponse) => {
  // const {session} = store.getState();
  // const trackNum = wResponse.response.trackingNumber;
  wResponse.response.reasonCode.map(
    // eslint-disable-next-line
    (reasonCode) => {
      const errReason = {
        status: 8,
        code: reasonCode,
        // desc: ' (correlation id: ' + session.correlationId + ')',
        // track: session.correlationId,
      };
      wResponse.reasons.push(errReason);
    },
  );
};

const commonErrorCheck = (wResponse) => {
  // empty response error.
  if (!wResponse.response) {
    wResponse.isError = true;
    if (wResponse.status === 200) {
      wResponse.status = 900;
    }
  }
  // status code 400+ error
  if (!wResponse.isError && wResponse.status > 399) {
    wResponse.isError = true;
  }
};

const responseConverter = (rxResponse, msgId) => {
  // console.log('rxResponse', rxResponse, msgId);
  // const {session} = store.getState();
  if (rxResponse.isError) {
    return rxResponse;
  }

  let wResponse = {
    status: 200,
    response: '',
    isError: false,
    msgId: msgId,
    xhr: '',
    reasons: [],
  };

  if (rxResponse.xhr) {
    wResponse.xhr = rxResponse.xhr;
    wResponse.status = rxResponse.status;
  }

  // IE11 issue
  if (rxResponse.name === 'SyntaxError') {
    wResponse.isError = true;
    wResponse.status = 901;
    wResponse.reasons.push({
      status: 16,
      code: 'HTTP_' + wResponse.status,
      // desc: 'API fatal error in IE11.' + ' (correlation id: ' + session.correlationId + ')',
      // track: session.correlationId,
    });
    return wResponse;
  }

  // Timeout
  if (rxResponse.name === 'TimeoutError') {
    wResponse.isError = true;
    wResponse.status = 902;
    wResponse.reasons.push({
      status: 16,
      code: 'HTTP_' + wResponse.status,
      // desc: 'API timeout.' + ' (correlation id: ' + session.correlationId + ')',
      // track: session.correlationId,
    });
    return wResponse;
  }

  let dummyStatus = null;
  if (rxResponse.request && rxResponse.request.headers['rxjs-hdr-status']) {
    dummyStatus = rxResponse.request.headers['rxjs-hdr-status'];
  }
  wResponse.response = rxResponse.response;
  wResponse.status = dummyStatus ? dummyStatus : rxResponse.status;

  // accreditation save don't have response
  if (rxResponse.status !== 200) {
    commonErrorCheck(wResponse);
  }

  // accreditation token 403 , call Saas Auth
  // if (rxResponse.status === 403) {
  //   console.log('rxResponse error============', rxResponse);
  //   return logon();
  // }

  if (rxResponse.name === 'AjaxError' || dummyStatus > 399) {
    wResponse.isError = true;
    // @@WP-REACT: customize the different BE response structure and extract error or warning
    // ref:	https://digital-confluence.systems.uk.hsbc/confluence/display/WENGCOMM/WP+API+error+response+scenario
    // ...
    if (wResponse.response && wResponse.response.errorInfo) {
      // wealth restful version 3
      restWithErrorInfoStyle(wResponse);
    } else if (
      wResponse.response &&
      wResponse.response.responseCode &&
      wResponse.response.responseCode
    ) {
      // wealth restful version 1
      // TODO: add handler
    } else if (wResponse.response && wResponse.response.trackingNumber) {
      // wealth restful version 2
      restWithCodeOnlyInfoStyle(wResponse);
    }
  }

  // if ajax error without reason code, create a http status code reason
  if (wResponse.isError && wResponse.reasons.length === 0) {
    wResponse.reasons.push({
      status: 16,
      code: 'HTTP_' + wResponse.status,
      // desc: ' (correlation id: ' + session.correlationId + ')',
      // track: session.correlationId,
    });
  }

  return wResponse;
};

export default responseConverter;
